function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from 'react';
import { ElementsProvider } from '../../core/elements';
import { DataTable } from '../../primitives/accessibility/DataTable';
import { LayoutContainer, Layout } from '../../primitives/container';
import { DimensionsWrapper } from '../../primitives/container/DimensionWrapper';
import { OrdinalLegend } from '../../primitives/legend';
import { LegendLabel, LegendSymbol } from '../../primitives/legend/OrdinalLegend';
import { MenuProvider, Menu } from '../../primitives/menu';
import { Arc } from '../../primitives/shape/Arc';
import { Theme } from '../../primitives/theme';
import { Subtitle, Title } from '../../primitives/title';
import { PIE_DEFAULT_MARGIN } from '../common/constants/constants';
import EventEmitterProvider from '../common/events/context/EventEmitterProvider';
import TooltipProvider from '../common/events/context/TooltipProvider';
import { SingleSeriesTooltip } from '../common/tooltip/SingleSeriesTooltip';
import { donutChartEvents } from './chart-events';
import { DonutMetric, DonutMetricLabel, DonutMetricValue } from './elements/donut-label';
import { DonutMarkLabels } from './elements/donut-stack-labels';
import { DonutMarks } from './elements/donut-stack-marks';
import { DonutScalesElement } from './elements/scale';
import { DonutTooltipOverlay } from './elements/tooltip-overlay';
import { PureDonutChart } from './pure';

/**
 * Props for the DonutChart component.
 *
 * @public
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A donut chart component.
 *
 * @public
 */
export default class DonutChart extends Component {
  render() {
    const {
      width,
      height,
      data,
      children,
      ...restProps
    } = this.props;
    return /*#__PURE__*/_jsx(ElementsProvider, {
      children: /*#__PURE__*/_jsx(TooltipProvider, {
        children: /*#__PURE__*/_jsx(MenuProvider, {
          children: /*#__PURE__*/_jsxs(EventEmitterProvider, {
            children: [children, /*#__PURE__*/_jsx(LayoutContainer, {
              width: width,
              height: height,
              data: data,
              gridTemplate: ['title', 'subtitle', 'plot', 'legend'],
              children: /*#__PURE__*/_jsx(DimensionsWrapper, {
                children: _ref => {
                  let {
                    plotHeight,
                    plotWidth,
                    plotSvgRef
                  } = _ref;
                  return /*#__PURE__*/_jsx(PureDonutChart, {
                    svgRef: plotSvgRef,
                    height: plotHeight,
                    width: plotWidth,
                    data: data,
                    margin: PIE_DEFAULT_MARGIN,
                    ...restProps
                  });
                }
              })
            })]
          })
        })
      })
    });
  }
}
_defineProperty(DonutChart, "events", donutChartEvents);
_defineProperty(DonutChart, "elements", {
  Legend: OrdinalLegend.Component,
  LegendLabel: LegendLabel.Component,
  LegendSymbol: LegendSymbol.Component,
  Layout: Layout.Component,
  Title: Title.Component,
  SubTitle: Subtitle.Component,
  Mark: Arc.Component,
  Marks: DonutMarks.Component,
  MarkLabels: DonutMarkLabels.Component,
  Metric: DonutMetric.Component,
  MetricLabel: DonutMetricLabel.Component,
  MetricValue: DonutMetricValue.Component,
  TooltipOverlay: DonutTooltipOverlay.Component,
  Tooltip: SingleSeriesTooltip.Component,
  Scales: DonutScalesElement.Component,
  Theme: Theme.Component,
  Menu: Menu.Component,
  DataTable: DataTable.Component
});